/**
 * MetadataToggles
 *
 * Checkbox group for controlling which metadata fields appear on exported slides.
 * Also includes the section divider toggle.
 */

import { Checkbox } from '../ui/Checkbox'
import type { MetadataOptions } from '@/types/SlideExport.types'

interface MetadataTogglesProps {
	metadata: MetadataOptions
	onToggle: (key: keyof MetadataOptions) => void
	includeDividers: boolean
	onToggleDividers: (value: boolean) => void
}

const METADATA_FIELDS: { key: keyof MetadataOptions; label: string }[] = [
	{ key: 'showPlayName', label: 'Play name' },
	{ key: 'showFormation', label: 'Formation' },
	{ key: 'showPersonnel', label: 'Personnel' },
	{ key: 'showPlayType', label: 'Play type' },
	{ key: 'showLabels', label: 'Labels' },
	{ key: 'showNotes', label: 'Notes' },
]

export function MetadataToggles({
	metadata,
	onToggle,
	includeDividers,
	onToggleDividers,
}: MetadataTogglesProps) {
	return (
		<div className="metadata-toggles">
			<span className="metadata-toggles__label">Include on slides</span>
			<div className="metadata-toggles__grid">
				{METADATA_FIELDS.map(({ key, label }) => (
					<label key={key} className="metadata-toggles__item">
						<Checkbox
							checked={metadata[key]}
							onCheckedChange={() => onToggle(key)}
						/>
						<span>{label}</span>
					</label>
				))}
				<label className="metadata-toggles__item">
					<Checkbox
						checked={includeDividers}
						onCheckedChange={(checked) => onToggleDividers(checked === true)}
					/>
					<span>Section dividers</span>
				</label>
			</div>
		</div>
	)
}
